"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AddFixedAssetToRentalModal_yaml_component_1 = __importDefault(require("./AddFixedAssetToRentalModal.yaml?component"));
const CreateWorksheetsFromWasteBinReadingsModal_yaml_component_1 = __importDefault(require("./CreateWorksheetsFromWasteBinReadingsModal.yaml?component"));
const FixedAsset_yaml_component_1 = __importDefault(require("./FixedAsset.yaml?component"));
const FixedAssetBrowser_yaml_component_1 = __importDefault(require("./FixedAssetBrowser.yaml?component"));
const MCreateFixedAsset_yaml_component_1 = __importDefault(require("./MCreateFixedAsset.yaml?component"));
const MFixedAssetEditor_yaml_component_1 = __importDefault(require("./MFixedAssetEditor.yaml?component"));
const MFixedAssetEditorFieldset_yaml_component_1 = __importDefault(require("./MFixedAssetEditorFieldset.yaml?component"));
const WasteBinReadingModal_yaml_component_1 = __importDefault(require("./WasteBinReadingModal.yaml?component"));
const WasteBinReadingsList_yaml_component_1 = __importDefault(require("./WasteBinReadingsList.yaml?component"));
const WasteBinsBrowser_yaml_component_1 = __importDefault(require("./WasteBinsBrowser.yaml?component"));
__exportStar(require("./form"), exports);
__exportStar(require("./primitives"), exports);
exports.default = [
    AddFixedAssetToRentalModal_yaml_component_1.default,
    CreateWorksheetsFromWasteBinReadingsModal_yaml_component_1.default,
    FixedAsset_yaml_component_1.default,
    FixedAssetBrowser_yaml_component_1.default,
    MCreateFixedAsset_yaml_component_1.default,
    MFixedAssetEditor_yaml_component_1.default,
    MFixedAssetEditorFieldset_yaml_component_1.default,
    WasteBinReadingModal_yaml_component_1.default,
    WasteBinReadingsList_yaml_component_1.default,
    WasteBinsBrowser_yaml_component_1.default
];
